module.exports = __webpack_public_path__ + "static/media/SignOut.7db59d71.svg";